<div class="max-w-md mx-auto bg-gray-50 rounded-xl shadow-lg overflow-hidden md:max-w-2xl m-4">
  <div class="p-6">
    <div class="uppercase tracking-wide text-lg text-indigo-600 font-bold text-center">番茄鐘</div>
    <p class="block mt-2 text-6xl font-mono leading-tight font-bold text-gray-800 text-center py-4 bg-gray-200 rounded-lg">{{remainTime}}</p>

    <div class="mt-5 grid grid-cols-2 gap-4">
      <app-jknumberedit [visible]="true" [label]="'工作 (分)'" [required]="true" [(value)]="waitMin" width="100%" [styleDisplay]="'flex'"></app-jknumberedit>
      <button class="btn-primary w-full h-full flex items-center justify-center" (click)="startTimer(waitMin,true)" [disabled]="buttonDisabled">
        <mat-icon class="mr-2">play_arrow</mat-icon>
        <span>工作開始</span>
      </button>
      <app-jknumberedit [visible]="true" [label]="'休息 (分)'" [required]="true" [(value)]="restMin" width="100%" [styleDisplay]="'flex'"></app-jknumberedit>
      <button class="btn-secondary w-full h-full flex items-center justify-center" (click)="startTimer(restMin,false)" [disabled]="buttonDisabled">
        <mat-icon class="mr-2">pause</mat-icon>
        <span>休息開始</span>
      </button>
    </div>

    <div class="mt-6 flex items-center justify-between p-3 bg-gray-100 rounded-lg">
      <app-jkcheckbox label="工作中" #MA015Com id="MA015" [(value)]="isWorking"></app-jkcheckbox>
      <button class="btn-warning flex items-center" (click)="resetTimer()">
        <mat-icon class="mr-2">clear_all</mat-icon>
        <span>歸零</span>
      </button>
    </div>

    <div class="mt-6">
      <h3 class="text-md font-semibold text-gray-700">快速設定</h3>
      <div class="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3">
        <button class="btn-outline-primary" (click)="startTimer(3,true)" [disabled]="buttonDisabled">工作3分鐘</button>
        <button class="btn-outline-primary" (click)="startTimer(25,true)" [disabled]="buttonDisabled">工作25分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(5,false)" [disabled]="buttonDisabled">休息5分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(10,false)" [disabled]="buttonDisabled">休息10分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(15,false)" [disabled]="buttonDisabled">休息15分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(20,false)" [disabled]="buttonDisabled">休息20分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(30,false)" [disabled]="buttonDisabled">休息30分鐘</button>
        <button class="btn-outline-secondary" (click)="startTimer(60,false)" [disabled]="buttonDisabled">休息60分鐘</button>
      </div>
    </div>

    <div class="mt-5 p-3 bg-gray-100 rounded-lg">
        <app-jkcheckbox label="使用雲端語音"  [(value)]="tts.isWebVoice" >
        </app-jkcheckbox>
    </div>

    <div class="mt-5">
      <app-jktextarea label="PS" [rows]="3" name="comment" id="comment" class="w-full" [required]="true"
      [(value)]="log"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400">
      </app-jktextarea>
    </div>
  </div>
</div>
